<template>
  <div>
    <v-layout>
      <v-flex xs12 sm4 md3>
        <book-filter @onFilterChanged="refresh"></book-filter>
      </v-flex>
      <v-flex xs12 sm8 md9>
        <v-data-table
          :headers="headers"
          :items="books"
          :search="search"
          select
          class="mt-3"
          @click:row="onBookSelected"
          v-model="selected"
          dense
          show-select
          :loading="loading"
        >
          <v-layout slot="top" class="ma-0 pa-0 align-center" style="min-height: 80px">
            <v-flex>
              <book-actions :selected="selected" @remove="onRemove" @update="onUpdate" />
              <book-assign-dialog :book="selectedBook" :state="assignState" />
            </v-flex>
          </v-layout>
          <template v-slot:item.code="{ item }">
            <router-link :to="'/book/' + item.id">{{item.code}}</router-link>
          </template>
          <template v-slot:item.staff="{ item }">
            <staff-name :staff="item.staff"></staff-name>
          </template>
          <template v-slot:item.date="{ item }">
            <div class="nowrap">{{item.date | familiarizeDate}}</div>
          </template>
          <template v-slot:item.deadline="{ item }">
            <div class="nowrap">{{item.deadline | familiarizeDate}}</div>
          </template>
          <template v-slot:item.staff="{ item }">
            <staff-name v-if="item.staff" :staff="item.staff"></staff-name>
          </template>
          <template v-slot:item.student="{ item }">
            <staff-name v-if="item.student" :staff="item.student"></staff-name>
          </template>
          <template v-slot:item.teacher="{ item }">
            <staff-name v-if="item.teacher" :staff="item.teacher"></staff-name>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip :color="getColor(item.status)" small dark>{{ allBookStatus[item.status] }}</v-chip>
          </template>
          <template v-slot:item.type="{ item }">
            <v-chip small dark>{{ allBookType[item.type] }}</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-layout>
              <v-tooltip top v-if="item.status!='using'">
                <template v-slot:activator="{ on }">
                  <v-icon class="mr-2" v-on="on" small @click.stop="onAssign(item)">pan_tool</v-icon>
                </template>
                <span>Cho Mượn</span>
              </v-tooltip>
              <v-tooltip top v-if="item.status==='using'">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small @click.stop="onReturnBook(item)">history</v-icon>
                </template>
                <span>Hoàn Trả</span>
              </v-tooltip>
            </v-layout>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import BookFilter from '@/modules/book/BookFilter'
import StaffName from '@/components/basic/card/CardStaffName'
import BookActions from '@/modules/book/BookActions'
import BookAssignDialog from '@/modules/book/BookAssignDialog.vue'
export default {
  components: {
    BookFilter,
    BookActions,
    BookAssignDialog,
    StaffName
  },
  data () {
    return {
      search: '',
      expanded: [],
      loading: false,
      assignState: false,
      selectedBook: {},
      selected: [],
      headers: [
        { text: 'Hành Động', value: 'actions', align: 'center' },
        {
          text: 'Mã',
          align: 'left',
          sortable: false,
          value: 'code'
        },
        { text: 'Tên', value: 'name' },
        { text: 'Trạng thái', value: 'status' },
        { text: 'Nhân Viên Mượn', value: 'staff' },
        { text: 'Học Sinh Mượn', value: 'student' },
        { text: 'Giáo Viên Mượn', value: 'teacher' },
        { text: 'Hạn Trả', align: 'right', value: 'deadline' },
        { text: 'Loại', value: 'type' },
        { text: 'Ngày mượn', value: 'date' }
      ],
      draw: false,
      bookId: ''
    }
  },
  computed: {
    ...mapGetters('books', ['books', 'book']),
    ...mapState('constant', ['bookStatus', 'bookTypes']),
    ...mapGetters('app', ['department']),
    allBookStatus () {
      return this.bookStatus.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title']
        }),
        {}
      )
    },
    allBookType () {
      return this.bookTypes.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title']
        }),
        {}
      )
    },
    bookData () {
      return this.book(this.bookId)
    }
  },
  methods: {
    ...mapActions('books', [
      'fetchBooks',
      'setBook',
      'removeBooks',
      'updateBook'
    ]),
    onBookSelected (book) {},
    async onRemove (books) {
      await this.removeBooks(books)
    },
    onUpdate (filter) {},
    onAssign (book) {
      this.selectedBook = book
      this.assignState = !this.assignState
    },
    onReturnBook (book) {
      this.$dialog.confirm({
        title: 'Xác Nhận Hoàn Trả CSVC',
        text: ` Xác nhận CSVC ${book.name} đã được hoàn trả`,
        okText: 'Xác Nhận',
        cancelText: 'Hủy',
        done: async () => {
          await this.updateBook({
            student: null,
            staff: null,
            teacher: null,
            deadline: null,
            date: null,
            'not-clear-request': true,
            status: 'inventory',
            id: book.id
          })
        }
      })
    },
    async refresh (query = { type: 'book' }) {
      this.loading = true
      await this.fetchBooks({ ...query })
      this.loading = false
    },
    getColor (status) {
      if (status === 'approved') return 'green'
      else if (status === 'rejected') return 'red'
      else if (status === 'opened') return 'blue'
      else if (status === 'canceled') return 'orange'
      else return 'gray'
    }
  },
  created: function () {
    if (this.books.length === 0) {
      this.refresh({
        type: 'book'
      })
    }
  },
  filters: {
    familiarizeDate: time => {
      if (!time) {
        return ''
      }
      return moment(time).format(' hh:mm Ngày DD/MM')
    },
    SimplizedDate: time => {
      if (!time) {
        return ''
      }
      return moment(time).format('DD/MM')
    }
  }
}
</script>

To change the font size for a single component, such as a text field, application-wide:

<style scoped>
.v-select__level-sale {
  font-size: 1em;
  border: none;
}
.nowrap {
  white-space: nowrap;
}
.content {
  margin: 0 !important;
  padding: 0 !important;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  width: 100%;
}
</style>
